import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import { router } from './router'
import { i18n } from './i18n'
import { initInstallPrompt } from './lib/install'
import { registerServiceWorker } from './lib/serviceWorker'
import './style.css'

// Výzva k instalaci PWA musí být zachycená dřív, než ji prohlížeč sám zobrazí (2.4).
initInstallPrompt()

// Service worker (offline, web push). V nativním WebView se přeskočí, push jde přes Capacitor.
registerServiceWorker()

const app = createApp(App)

const dsn = import.meta.env.VITE_SENTRY_DSN
if (dsn) {
  Sentry.init({
    app,
    dsn,
    release: __APP_VERSION__,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
  })
}

app.use(createPinia())
app.use(i18n)
app.use(router)
app.mount('#app')
